import { useEffect, useState, type FC } from "react";
import { Input, TextField } from "@heroui/react";
import {
  formatHelpPhone,
  toHelpPhoneDigits,
  toStoredHelpPhone,
} from "../helpPhone";

interface HelpPhoneFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isInvalid?: boolean;
}

const HelpPhoneField: FC<HelpPhoneFieldProps> = ({
  value,
  onChange,
  placeholder = "+7 (___) ___-__-__",
  isInvalid = false,
}) => {
  const [digits, setDigits] = useState(() => toHelpPhoneDigits(value));

  useEffect(() => {
    const incoming = toHelpPhoneDigits(value);
    setDigits((current) => (current === incoming ? current : incoming));
  }, [value]);

  return (
    <div className="help-phone-field">
      <TextField fullWidth isInvalid={isInvalid}>
        <Input
          inputMode="tel"
          autoComplete="tel"
          placeholder={placeholder}
          value={formatHelpPhone(digits)}
          onChange={(event) => {
            const next = toHelpPhoneDigits(event.target.value);
            setDigits(next);
            onChange(toStoredHelpPhone(next));
          }}
        />
      </TextField>
    </div>
  );
};

export default HelpPhoneField;
